import "./App.css";
import Dictionary from "./Dictionary.js";

function App() {
  return (
    <div className="App">
      <Dictionary />
      <footer className="text-center">
        This project is coded by <a href="#">Michelle</a>, open sourced on
        netlify and hosted on gitHub.
      </footer>
    </div>
  );
}

export default App;
